// extracted by mini-css-extract-plugin
export default {"bookingButtons":"styles_bookingButtons__jJn7a","bookingButtons__whatsapp":"styles_bookingButtons__whatsapp__hNgu8","bookingButtons__webchat":"styles_bookingButtons__webchat__sQVCg"};